import { makeApiUrl } from '../helpers/makeApiUrl';
import { authHeader } from '../helpers/authHeader';
import { handleResponse } from '../helpers/handleResponse';
import { escapeNonAsciiChars } from './utils';





const requestOptions = () => {
    return {
        method: 'POST',
        headers: authHeader(),
    }
};

const urlPrefix = 'project-prices'

const userPrivileges = async () => {
    return fetch(makeApiUrl(`${urlPrefix}/privileges`, 'internal'), requestOptions())
        .then(handleResponse)
}

const projects = async (vendor, abortController) => {
    const body = new FormData();
    const { signal } = abortController
    body.append('vendorId', vendor);
    return fetch(makeApiUrl(`${urlPrefix}/projects`, 'internal'), {...requestOptions(), body, signal})
        .then(handleResponse)
        .catch(() => {})
}

const project = async (projectId) => {
    const body = new FormData();
    body.append('projectId', projectId);
    return fetch(makeApiUrl(`${urlPrefix}/project`, 'internal'), {...requestOptions(), body})
        .then(handleResponse)
}

const loadCart2AB = async (cart) => {
    let data = []
    for (const item of cart) {
        data.push(item[1])
    }
    const body = new FormData();
    body.append('cart', JSON.stringify(data));
    return fetch(makeApiUrl(`${urlPrefix}/add-projects-2-cart`, 'internal'), {...requestOptions(), body})
        .then(handleResponse)
}

const products = async (vendor, abortController) => {
    const body = new FormData()
    const { signal } = abortController
    body.append('vendorId', vendor)
    return fetch(makeApiUrl(`${urlPrefix}/products`, 'internal'), {...requestOptions(), body, signal })
        .then(handleResponse)
        .catch(()=> {})
}

const product = async () => {
    return fetch(makeApiUrl(`${urlPrefix}/product`, 'internal'), requestOptions())
        .then(handleResponse)
}

const loadProductsCart2AB = async (cart) => {
    let data = []
    for (const item of cart) {
        data.push(item[1])
    }

    const body = new FormData();
    body.append('cart', JSON.stringify(data));
    return fetch(makeApiUrl(`${urlPrefix}/add-products-2-cart`, 'internal'), {...requestOptions(), body})
        .then(handleResponse)
}

const cart = async (abortController) => {
    const { signal } = abortController
    return fetch(makeApiUrl(`${urlPrefix}/cart`, 'internal'), {...requestOptions(), signal})
        .then(handleResponse)
        .catch(() => {})
}

const updateCart = async (content) => {
    const body = new FormData()
    body.append('content', JSON.stringify(content))
    return fetch(makeApiUrl(`${urlPrefix}/update-cart`, 'internal'), {...requestOptions(), body})
        .then(handleResponse)
}

const acceptTermsOfUse = async () => {
    return fetch(makeApiUrl(`${urlPrefix}/accept-terms-of-use`, 'internal'), requestOptions())
        .then(handleResponse)
}

const customers = async (withErpCustomers = false) => {
    const body = new FormData()
    if (withErpCustomers) {
        body.append('withErpCustomers', withErpCustomers);
    }
    return fetch(makeApiUrl(`${urlPrefix}/customers`, 'internal'), { ...requestOptions(), body })
        .then(handleResponse)
}

const customer = async (customerId) => {
    return fetch(makeApiUrl(`${urlPrefix}/customer/${customerId}`, 'internal'), requestOptions())
        .then(handleResponse)
}

const updateCustomer = async (customer) => {
    const body = new FormData()
    body.append('customer', JSON.stringify(customer))
    return fetch(makeApiUrl(`${urlPrefix}/update-customer`, 'internal'), {...requestOptions(), body})
        .then(handleResponse)
}

const addCustomer = async (customer) => {
    const body = new FormData()
    body.append('customer', JSON.stringify(customer))
    return fetch(makeApiUrl(`${urlPrefix}/add-customer`, 'internal'), {...requestOptions(), body})
        .then(handleResponse)
}

const removeProjectFeatureValues = async (projectId) => {
    const body = new FormData()
    body.append('project_id', projectId)
    return fetch(makeApiUrl(`${urlPrefix}/remove-feature-values`, 'internal'), {...requestOptions(), body})
        .then(handleResponse)
}

export const projectPricesServices = {
    projects,
    project,
    loadCart2AB,
    products,
    product,
    loadProductsCart2AB,
    cart,
    updateCart,
    acceptTermsOfUse,
    userPrivileges,
    customers,
    customer,
    updateCustomer,
    addCustomer,
    removeProjectFeatureValues,
};
